var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, ["title", "titleId"]);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.307,
    height: 13.307,
    viewBox: "0 0 13.307 13.307",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Logout",
    transform: "translate(-1990.876 -784.875)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1225",
    "data-name": "Path 1225",
    d: "M1992.589,794.44h5.967a.6.6,0,1,0,0-1.191h-5.967l.678-.678a.6.6,0,1,0-.843-.843l-1.15,1.15h0a1.369,1.369,0,0,0,0,1.932l1.149,1.149a.6.6,0,0,0,.843-.843Z",
    transform: "translate(0 -2.291)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1226",
    "data-name": "Path 1226",
    d: "M2004.069,784.875h-5.16a2.141,2.141,0,0,0-2.136,2.136v1.026a.6.6,0,1,0,1.191,0v-1.026a.947.947,0,0,1,.945-.945h5.161a.947.947,0,0,1,.944.944v9.037a.947.947,0,0,1-.944.944h-5.161a.948.948,0,0,1-.944-.944V795.02a.6.6,0,0,0-1.185-.082l-.006,1.109a2.141,2.141,0,0,0,2.136,2.135h5.161a2.141,2.141,0,0,0,2.135-2.135v-9.036A2.142,2.142,0,0,0,2004.069,784.875Z",
    transform: "translate(-2.022 0)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/Logout.b5a5be31.svg";
export { ForwardRef as ReactComponent };